import {
  JbModal
} from "./chunk.ANE27JCW.js";
import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.A7Z76YXE.js";
import {
  jb_contact_overlay_css_default
} from "./chunk.MNHVQDU2.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  Animatable
} from "./chunk.V3FEQEPV.js";
import {
  recenterNavItems
} from "./chunk.JTCOOS2A.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-contact-overlay/jb-contact-overlay.ts
var JbContactOverlay = class extends Initiable(Spaceable(Animatable(i))) {
  async firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    await this.updateComplete;
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_form",
          event_version: "v2",
          component_name: "contact-overlay",
          form_component: this._form,
          form_step_name: "form open",
          form_step_nr: "1",
          form_subject: this.formToDisplay.trackingSubject || "",
          form_type: "contact"
        },
        bubbles: true,
        composed: true
      })
    );
    this.contentChildren = [];
    const formHeader = this._form.shadowRoot.querySelector(".formheader");
    if (formHeader) {
      this.contentChildren.push(...Array.from(formHeader.children));
    }
    const formTitle = this._form.shadowRoot.querySelector("jb-heading.formtitle");
    if (formTitle) {
      this.contentChildren.push(formTitle);
    }
    this._form.addEventListener("jb-form:ready", () => {
      this.contentChildren.push(...Array.from(this._form.children));
      this.contentChildren.forEach((element) => {
        element.style.setProperty("opacity", "0");
      });
    });
    document.addEventListener("jb-modal:close", () => {
      this._prepareToClose();
    });
    if (document.querySelector("jb-focus-fly")?._isVisible()) {
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
      }, 500);
    } else {
      setTimeout(() => {
        this.shadowRoot.activeElement?.blur();
      }, 100);
    }
  }
  static async open(modalProps, contactOverlayProps) {
    const contactOverlay = new JbContactOverlay();
    contactOverlay.init({
      props: {
        ...contactOverlayProps,
        slot: "content",
        withSpacing: true
      }
    });
    new JbModal().init({
      props: modalProps,
      childNodes: [contactOverlay]
    }).stack();
    disableBodyScroll(contactOverlay, { allowTouchMove: () => true });
    recenterNavItems();
    contactOverlay.addEventListener("jb-form:ready", async () => {
      await contactOverlay.animateWrapper();
      await contactOverlay.animateWrapperControls();
      contactOverlay.animateContent();
    });
  }
  _captureTracking(evt) {
    evt.stopPropagation();
  }
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 8, colsLgUp: 6 };
  }
  async _prepareToClose() {
    await this.hide();
    const { parentElement } = this;
    const grandparentElement = parentElement.parentElement;
    if (parentElement.tagName === "JB-MODAL") {
      parentElement.unstack();
    }
    if (grandparentElement.tagName === "JB-MODAL") {
      grandparentElement.unstack();
    }
    enableBodyScroll(this);
    recenterNavItems();
  }
  render() {
    return b`
      <jb-form
        .action=${this.formToDisplay.action}
        .additionalData=${this.formToDisplay.additionalData}
        .bordered=${this.formToDisplay.bordered}
        .contentElements=${this.formToDisplay.contentElements}
        .formHeader=${this.formToDisplay.formHeader}
        .formIdentifier=${this.formToDisplay.formIdentifier}
        .generalConcern=${this.formToDisplay.generalConcern}
        .multiformSubline=${this.formToDisplay.multiformSubline}
        .recipient="${this.formToDisplay.recipient}"
        .recipientPhone=${this.formToDisplay.recipientPhone}
        .recipientPosition=${this.formToDisplay.recipientPosition}
        .trackingSubject=${this.formToDisplay.trackingSubject}
        .validationFieldname=${this.formToDisplay.validationFieldname}
        displayGrid
        @jb-tracking=${this._captureTracking}
      ></jb-form>
    `;
  }
};
JbContactOverlay.styles = [reset_css_default, jb_contact_overlay_css_default];
__decorateClass([
  n()
], JbContactOverlay.prototype, "formIdentifier", 2);
__decorateClass([
  n({ type: Object })
], JbContactOverlay.prototype, "formToDisplay", 2);
__decorateClass([
  n()
], JbContactOverlay.prototype, "svgLogo", 2);
__decorateClass([
  e("jb-form")
], JbContactOverlay.prototype, "_form", 2);
JbContactOverlay = __decorateClass([
  customElement("jb-contact-overlay")
], JbContactOverlay);

export {
  JbContactOverlay
};
